import countdownDate from '../util/countdown_date'

up.compiler('.js-plan_countdown', element => {
  const dateString = element.dataset.countdownEndsAt
  const countdownEndsAt = new Date(dateString)

  element.textContent = countdownDate(countdownEndsAt)
  element.classList.add('test-plan_countdown_date_text')

  // Keep updating the text, to make the count go down in real time
  // without a page refresh
  const interval = setInterval(() => {
    const newContent = countdownDate(countdownEndsAt)
    // don't replace content if not necessary because that removes user text selection
    if (element.textContent !== newContent) {
      element.textContent = newContent
    }
  }, 100)

  return function () {
    clearInterval(interval)
  }
})
